
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/register/[pid]",
      function () {
        return require("private-next-pages/account/register/[pid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/register/[pid]"])
      });
    }
  